import { render, staticRenderFns } from "./ImportantNew.vue?vue&type=template&id=53c30044&scoped=true"
import script from "./ImportantNew.vue?vue&type=script&lang=js"
export * from "./ImportantNew.vue?vue&type=script&lang=js"
import style0 from "./ImportantNew.vue?vue&type=style&index=0&id=53c30044&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c30044",
  null
  
)

export default component.exports